<div class="dialog-container">
  <h2 class="dialog-title">Unauthorized Access</h2>
  <p class="dialog-message">Your session has expired. Please log in again.</p>
  <button mat-button class="dialog-button" (click)="onClose()">Close</button>
</div>
